import { Locales, Series } from '@types';
import { LOCATIONS } from '@utils/locations';

const PARIS_NIGHT: Series = {
  id: 'paris_night',
  name: { [Locales.EN]: 'Paris, Night', [Locales.FR]: 'Paris, nuit' },
  location: LOCATIONS.PARIS,
};

export default PARIS_NIGHT;
